import React from 'react';
import cx from 'classnames';

interface Props {
  tailwindColor?: string;
  className?: string;
}

const TagsIcon: React.FC<Props> = ({ tailwindColor = `flgray-900`, className }) => (
  <svg
    className={cx(className, `inline-block`)}
    width="17"
    height="18"
    viewBox="0 0 13 18"
  >
    <path
      className={cx(`text-${tailwindColor}`, `fill-current`)}
      d="M0.380046101,17.9985035 C0.163826897,17.9780655 -0.000811698013,17.796577 3.010466e-06,17.5799336 L3.010466e-06,0.418569848 C3.010466e-06,0.187205364 0.187568655,0 0.41936059,0 L12.5806424,0 C12.8124407,0 13.000003,0.187211643 13.000003,0.418569848 L13.000003,17.5799336 C13.000003,17.7344445 12.9139958,17.8775158 12.7772149,17.9502633 C12.6396142,18.0230233 12.4733506,18.013212 12.3447555,17.9265555 L6.50000301,13.9043085 L0.655247522,17.9265555 C0.574980965,17.9813295 0.477512485,18.0066718 0.380046101,17.9984972 L0.380046101,17.9985035 Z M0.838715137,16.7885855 L6.26411458,13.0541053 C6.40663013,12.9568213 6.59337081,12.9568213 6.73588845,13.0541053 L12.1612879,16.7885855 L12.1612879,0.837097839 L0.838715137,0.837097839 L0.838715137,16.7885855 Z"
      transform="matrix(-1 0 0 1 13 0)"
    />
  </svg>
);

export default TagsIcon;
